import DonationBanner from '@/components/blocks/donation_banner/DonationBanner';

export default async function DonationBannerContent({ block, position }) {
  const data = block.donation_banner.reference[0];
  return <DonationBanner block={data} position={position} />;
}
